import { FieldDefinition, ISelectFormField } from 'types/form-types';

const isSelectField = <DataModel>(
  fieldDefinition: FieldDefinition<DataModel>
): fieldDefinition is ISelectFormField<DataModel> => {
  return 'options' in fieldDefinition;
};

export { isSelectField };
